import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowUp_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967L7.46967 1.46967C7.61032 1.32902 7.80109 1.25 8 1.25C8.19891 1.25 8.38968 1.32902 8.53033 1.46967L12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033C12.2374 6.82322 11.7626 6.82322 11.4697 6.53033L8.75 3.81066L8.75 14C8.75 14.4142 8.41421 14.75 8 14.75C7.58578 14.75 7.25 14.4142 7.25 14L7.25 3.81066L4.53033 6.53033C4.23744 6.82322 3.76256 6.82322 3.46967 6.53033Z"
            />
        </SvgStyled>
    );
};

export default ArrowUp_xs;
